import React, { Component } from 'react'
import { getDailyScheduleReport } from "../../store/actions";
import { connect } from "react-redux";
import Select from "react-select";
import Loader from '../../components/loader';

const getSelectStyles = (width = '200px') => ({
    control: (provided, state) => ({
        ...provided,
        width: width,
        margin: '0px',
        borderColor: state.isFocused ? '#47E5EB' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #47E5EB' : null,
        '&:hover': {
            borderColor: state.isFocused ? '#47E5EB' : '#ccc'
        }
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#47E5EB' : 'white',
        color: state.isSelected ? 'white' : 'black',
        '&:hover': {
            backgroundColor: state.isSelected ? '#47E5EB' : '#46e6ec33'
        },
    })
});


class dailySchedule extends Component {
    constructor(props) {
        super(props);
    };

    dateOptions = [
        {
            label: "Today",
            value: false
        },
        {
            label: "Tomorrow",
            value: true
        }
    ];

    state = {
        loading: true,
    };

    runReport = async (companyShortName, isTomorrow) => {

        this.setState({ loading: true, pdfUrl: undefined });
        let res = await getDailyScheduleReport(companyShortName, isTomorrow);
        const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));

        //window.open(url);
        this.setState({ loading: false, pdfUrl: url });
    };

    selectDateOption = selectedOption => {
        this.setState({ selectedOption });
    };

    async componentDidMount() {

        this.setState({
            loading: false,
            selectedOption: this.dateOptions[0]
        });
    }


    render() {
        let { selectedOption, loading, pdfUrl } = this.state;
        return (
            <div className="df ffc wp_report_page" style={{ height: "100%" }}>
                <div className="df download_actns">
                    <div className="mla"></div>
                </div>
                <div className="df filters_wrpr mb-5" >
                    <div className='ps-1' style={{ padding: '5px' }}>
                        <Select
                            placeholder="Report Date"
                            options={this.dateOptions}
                            value={selectedOption}
                            onChange={this.selectDateOption}
                            styles={getSelectStyles()}
                        >
                        </Select>
                    </div>
                    <div className="df mla" style={{ padding: '5px' }}>
                        <button
                            className="ttuc fs16 primary report"
                            onClick={() => {
                                this.runReport(this.props.UserReducer.company, selectedOption.value);
                            }}
                        >
                            Run
                        </button>
                    </div>
                </div>

                <div style={{ height: "100%", width: "100%" }}>
                    {loading ? (
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "75%"
                        }}>
                            <h3>Preparing your report...</h3>
                            <h4>Please wait...</h4>
                            <div className="ec_setup_contact df acc loading">
                                <Loader></Loader>
                            </div>
                        </div>

                    ) : (
                        <>
                            {!loading && pdfUrl && <object data={pdfUrl} width="100%" height="100%"></object>}
                            {!loading && !pdfUrl && <div className="df acc table_wrpr" style={{ height: "100%" }}>
                                <p style={{ fontSize: "24px" }}>
                                    Please click RUN to generate the report
                                </p>
                            </div>}
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ UserReducer, }) => {
    return { UserReducer, }
};

export default connect(mapStateToProps, {

})(dailySchedule);